import { useUserRoles } from 'legacy/lut/hooks/useUserRoles'
import { useCallback } from 'react'

import { getUrlWithParams } from 'core-components/helpers/url'
import { isSimulation } from 'core/classes/helpers/StorageHelper'
import { useNavigate } from 'core/hooks/useNavigate'
import { useStartSimulationMutation } from 'core/store/service/simulation'

import { CommitmentTypes } from './enums'
import type { AcknowledgmentCommitmentItem } from './types'

/**
 * Simulating a signer, as the partner page's acknowledgment offers it: testers and super admins
 * only, never from inside a simulation. A partner signer is taken to the partner page first.
 */
export const useAcknowledgmentSimulation = () => {
  const navigate = useNavigate()
  const [startSimulation] = useStartSimulationMutation()
  const { isP360Tester, isSuperAdmin } = useUserRoles()

  const canSimulate = !isSimulation() && (isP360Tester || isSuperAdmin)

  const simulate = useCallback(
    (item: AcknowledgmentCommitmentItem) => {
      if (!item.SignerEmail) {
        return
      }

      if (item.CommitmentType === CommitmentTypes.Partner) {
        navigate(getUrlWithParams({ page: 'p360' }))
      }

      void startSimulation(item.SignerEmail)
    },
    [navigate, startSimulation]
  )

  return { canSimulate, simulate }
}
